import { writable } from 'svelte/store';

export interface UploadProgress {
    version: number;
    chunkIndex: number;
    totalChunks: number;
    chunkSize: number;
    progress: number;
    status: 'idle' | 'uploading' | 'completed' | 'failed';
}

const initialState: UploadProgress = {
    version: 0,
    chunkIndex: 0,
    totalChunks: 0,
    chunkSize: 0,
    progress: 0,
    status: 'idle'
};

function createUploadStore() {
    const { subscribe, set, update } = writable<UploadProgress>(initialState);

    return {
        subscribe,
        updateProgress: (progress: Omit<UploadProgress, 'status' | 'progress'>) => {
            const progressPercentage = progress.totalChunks > 0 
                ? (progress.chunkIndex) / (progress.totalChunks) * 100
                : 0;
            update(state => ({
                ...progress,
                progress: progressPercentage,
                status: progress.chunkIndex === progress.totalChunks ? 'completed' : 'uploading'
            }));
        },
        setFailed: () => {
            update(state => ({ ...state, status: 'failed' }));
        },
        reset: () => set(initialState)
    };
}

export const uploadStore = createUploadStore();